import React from "react";

export const CV = () => (
    <>
        <h1>
            This is my CV
        </h1>
    </>
);